import { render, staticRenderFns } from "./PcfCalculation.vue?vue&type=template&id=1b93e761"
import script from "./PcfCalculation.vue?vue&type=script&lang=js"
export * from "./PcfCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports